import { amplifyConfig } from './shared/services/authConfig';
import { Amplify } from 'aws-amplify';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import './index.css';
Amplify.configure(amplifyConfig);

// Add preconnect for API domain from env
const apiDomain = import.meta.env['VITE_API_DOMAIN_NAME'];
if (apiDomain) {
  const preconnect = document.createElement('link');
  preconnect.rel = 'preconnect';
  preconnect.href = `https://${apiDomain}`;
  document.head.appendChild(preconnect);

  const dnsPrefetch = document.createElement('link');
  dnsPrefetch.rel = 'dns-prefetch';
  dnsPrefetch.href = `https://${apiDomain}`;
  document.head.appendChild(dnsPrefetch);
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
